import { HiOutlineArrowNarrowUp } from "react-icons/hi";

const TestMinMax = ({
  value,
  min,
  max,
  unit,
  status,
}: {
  value: number;
  min: number;
  max: number;
  unit: string;
  status: string;
}) => {
  const normalizedValue = ((value - min) / (max - min)) * 100;

  return (
    <div className="relative w-full max-w-[500px] lg:w-[500px] rounded-full mt-10 flex gap-1">
      <div
        className="absolute z-10 top-0 bg-transparent h-[10px] w-[10px] rounded-full border-[2px] border-white"
        style={{
          left: ` ${
            status === "L" ? "10" : status === "H" ? "90" : normalizedValue
          }%`,
          transform: "translateX(-50%)",
        }}
      >
        <div className="absolute z-10 left-1 -bottom-[47px] -translate-x-1/2 text-red flex flex-col items-center">
          <HiOutlineArrowNarrowUp size={21} className="text-gray-800" />
          <p
            className="text-sm font-bold flex items-end"
            style={{ whiteSpace: "nowrap", direction: "ltr" }}
          >
            {value}{" "}
            <span
              className="font-light ml-1"
              style={{ fontSize: "11px", lineHeight: 1.5 }}
            >
              {unit}
            </span>
          </p>
        </div>
      </div>

      <div
        className="relative z-0 flex-1 h-[10px] rounded-full"
        style={{
          background: `linear-gradient(${
            !min ? "260deg" : "90deg"
          }, rgba(26,191,152,1) 0%, rgba(250,110,0,1) 100%)`,
        }}
      ></div>
    </div>
  );
};

export default TestMinMax;
